//@flow
import React from 'react';
import styled from 'styled-components';
import Draggable from 'react-draggable';
import OlMap from 'ol/map';
import customControl from './customControl';
import OlSourceVector from 'ol/source/vector';
import OlLayerVector from 'ol/layer/vector';
import OlStyleStyle from 'ol/style/style';
import OlStyleFill from 'ol/style/fill';
import OlStyleStroke from 'ol/style/stroke';
import OlStyleCircle from 'ol/style/circle';
import OlFeature from 'ol/feature';
import OlGeomPoint from 'ol/geom/point';
import OlGeomPolygon from 'ol/geom/polygon';
import OlGeomLineString from 'ol/geom/linestring';
import OlSphere from 'ol/sphere';
import OlOverlay from 'ol/overlay';
import OlObservable from 'ol/observable';
import OlInteractionDraw from 'ol/interaction/draw';
import OlInteractionDoubleClickZoom from 'ol/interaction/doubleclickzoom';
import OlInteractionSelect from 'ol/interaction/select';
import OlProj from 'ol/proj';
import { translate } from "react-i18next";
import '../../../../css/react-draggable/css/styles.css';
import '../../../../css/measure-popup/css/styles.css';
import IconClose from '../../../../icons/exit.svg';
import IconMeasurePoint from '../../../../icons/measurePoint.svg';
import IconMeasureDistance from '../../../../icons/measureDistance.svg';
import IconMeasureArea from '../../../../icons/measureArea.svg';
import IconClear from '../../../../icons/clear.svg';
import measurementsIcon from '../../../../icons/measurements.svg'
import SelectInput from './../../../../components/SelectInput';

const PopupWindow = styled.div`
    background: #fff;
    border-radius: 3px;
    width: 180px;
    margin: 10px;
    float: left;
    z-index: 2;
    pointer-events: auto;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.4);
`

const PopupHeader = styled.div`
  background-color: #265a9c;
  border-radius: 3px 3px 0 0;
  height: 24px;
  display: flex;
  justify-content: space-between;
  text-align: center;
  color: white;
  font-size: 12px;
  font-family: Open Sans, sans-serif;
  align-items: center;
  padding-left: 5px;
  cursor: grab;
`

const PopupContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2px;
`

const MeasureButton = styled.button`  
  background-color: rgba(86, 76, 94, 0.1);
  margin: 1px;
  text-align: center;
  font-family: Open Sans, sans-serif;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  :hover {
    -webkit-box-shadow: 0px 0px 3px 1px rgba(0,0,0,0.3);
    box-shadow: 0px 0px 3px 1px rgba(0,0,0,0.3);
  }
`

const CloseButton = styled.button`
  display: flex;
  align-items: center;
  height: 100%;  
  background-color: transparent;
  border: none;

  :hover {
    -webkit-box-shadow: 0px 0px 3px 1px rgba(0,0,0,0.14);
    box-shadow: 0px 0px 3px 1px rgba(0,0,0,0.14);
  }
  img {
    height: 18px;
  }
`;

const StyledIcon = styled.img`
  height: 20px;
  margin: 2px;
`;

const MeasurementValue = styled.div`
  margin: 0;
  font-size: 13px;
  display: ${(props) => props.visible ? 'flex' : 'none'};
  flex-direction: column;
  justify-content: center;
  align-items: center;
  >p,b {
    margin: 0
  }
`;
type CoordinateSystem = {
  name: string,
  value: string,
}
type MeasurePopupState = {
  visible: boolean,
  lastMeasurement: string,
  coordinateSystem: CoordinateSystem,
  allowedCoordinateSystems: array<CoordinateSystem>,
}

type MeasurePopupProps = {
  olMap: OlMap
};

const continuePolygonMsg = 'Click to continue drawing the polygon';
const continueLineMsg = 'Click to continue drawing the line';

export class MeasurePopup extends React.Component<MeasurePopupProps, MeasurePopupState> {
  sketch: OlFeature;
  helpTooltipElement: any;
  helpTooltip: OlOverlay;
  draw: OlInteractionDraw;
  source: OlSourceVector;
  vector: OlLayerVector;
  geometryChangeListener: any;
  pointerMoveListener: any;
  measureTooltipElement: any;
  measureTooltip: OlOverlay;
  dblClickInteraction: OlInteractionDoubleClickZoom;
  selectInteractions: Array<OlInteractionSelect> = [];
  measureControl: customControl;

  constructor(props) {
    super(props);
    const { olMap, t }: MeasurePopupProps = props;

    // dodanie przycisku pomiarow
    this.measureControl = new customControl({
      onClick: this.onMeasureButtonClick,
      className: 'ol-measure-button',
      title: t('Measure tools'),
      innerHTML: '<img width="20px" height="20px" src=' + measurementsIcon + '></img>',
      parent: this
    });
    olMap.addControl(this.measureControl);

    // dodanie warstwy pomiarow
    this.source = new OlSourceVector();
    const vector = new OlLayerVector({
      source: this.source,
      zIndex: 100,
      name: 'Measurements',
      style: new OlStyleStyle({
        fill: new OlStyleFill({
          color: 'rgba(255, 255, 255, 0.2)'
        }),
        stroke: new OlStyleStroke({
          color: '#1c58ff',
          width: 2
        }),
        image: new OlStyleCircle({
          radius: 7,
          fill: new OlStyleFill({
            color: '#1c58ff'
          })
        })
      })
    });
    olMap.addLayer(vector);

    this.state = {
      visible: false,
      lastMeasurement: '',
      coordinateSystem: { name: 'WGS84 ', value: 'EPSG:4326' },
      allowedCoordinateSystems: [
        { name: 'WGS84 ', value: 'EPSG:4326' },
        { name: 'British National Grid', value: 'EPSG:27700' },
        { name: '2000 zone 5', value: 'EPSG:2176' },
        { name: '2000 zone 6', value: 'EPSG:2177' },
        { name: '2000 zone 7', value: 'EPSG:2178' },
        { name: '2000 zone 8', value: 'EPSG:2179' },
      ]
    };
  }

  onMeasureButtonClick(mapComponent) {
    mapComponent.setState({
      visible: !mapComponent.state.visible
    });
  }

  measurePoint(): void {
    this.stopDrawing();
    this.startDrawing('Point');
  }

  measureDistance(): void {
    this.stopDrawing();
    this.startDrawing('LineString');
  }

  measureArea(): void {
    this.stopDrawing();
    this.startDrawing('Polygon');
  }

  clear(): void {
    const { olMap } = this.props;
    olMap
      .getOverlays()
      .getArray()
      .filter(overlay => overlay.typeId === "measure-tooltip")
      .forEach(overlay => olMap.removeOverlay(overlay));

    this.source.clear();
    this.setState({ lastMeasurement: '' });
  }

  close(): void {
    this.stopDrawing();
    this.setState({
      visible: false
    });
  }

  stopDrawing(): void {
    const { olMap }: MeasurePopupProps = this.props;
    if (this.draw) {
      this.sketch = null;

      olMap.removeInteraction(this.draw);
      this.draw = null;
      OlObservable.unByKey(this.pointerMoveListener);
      if (this.geometryChangeListener) {
        OlObservable.unByKey(this.geometryChangeListener);
      }

      if (this.measureTooltipElement) {
        this.measureTooltipElement.parentNode.removeChild(this.measureTooltipElement);
        this.measureTooltipElement = null;
      }

      this.helpTooltipElement.parentNode.removeChild(this.helpTooltipElement);
      this.helpTooltipElement = null;
      setTimeout(() => {
        olMap.addInteraction(this.dblClickInteraction)
        this.selectInteractions.forEach(interaction => {
          olMap.addInteraction(interaction)
        });
      });
    }
  }

  startDrawing(type: String) {
    const { olMap }: MeasurePopupProps = this.props;
    this.selectInteractions = [];
    olMap.getInteractions().getArray().forEach((interaction) => {
      if (interaction instanceof OlInteractionDoubleClickZoom) {
        this.dblClickInteraction = interaction;
      }
      if (interaction instanceof OlInteractionSelect) {
        this.selectInteractions.push(interaction);
      }
    });
    this.createDrawInteraction(type);
    olMap.removeInteraction(this.dblClickInteraction);
    this.selectInteractions.forEach(interaction => {
      olMap.removeInteraction(interaction)
    });
    olMap.addInteraction(this.draw);

    this.createMeasureTooltip();
    this.createHelpTooltip();

    this.draw.on('drawstart', this.drawStartHandler, this);
    this.draw.on('drawend', this.drawEndHandler, this);
    this.pointerMoveListener = olMap.on('pointermove', this.pointerMoveHandler, this);

    const helpTooltipElement = this.helpTooltipElement;
    olMap.getViewport().addEventListener('mouseout', function () {
      helpTooltipElement.classList.add('hidden');
    }, this);
  }

  drawStartHandler(evt) {
    // set sketch
    this.sketch = evt.feature;
    let tooltipCoord = evt.coordinate;

    if (evt.feature.getGeometry() instanceof OlGeomPoint) {
      var geom = evt.feature.getGeometry();
      this.measureTooltipElement.innerHTML = this.formatCoordinates(geom);
      this.setState({ lastMeasurement: this.formatCoordinates(geom) })
      this.measureTooltip.setPosition(geom.flatCoordinates);
    }
    else {
      this.geometryChangeListener = this.sketch.getGeometry().on('change', function (evt) {
        var geom = evt.target;
        var output;
        if (geom instanceof OlGeomPolygon) {
          output = this.formatArea(geom);
          tooltipCoord = geom.getInteriorPoint().getCoordinates();
        } else if (geom instanceof OlGeomLineString) {
          output = this.formatLength(geom);
          tooltipCoord = geom.getLastCoordinate();
        }
        this.measureTooltipElement.innerHTML = output;
        this.setState({ lastMeasurement: output })
        this.measureTooltip.setPosition(tooltipCoord);
      }, this);
    }
  }

  drawEndHandler(evt) {
    // Leave measure on the map, prevent from removing by stopDrawing method
    this.measureTooltipElement.className = 'tooltip tooltip-static';
    this.measureTooltip.setOffset([0, -7]);
    this.measureTooltipElement = null;
    this.stopDrawing();
  }

  pointerMoveHandler(evt) {
    if (evt.dragging) {
      return;
    }

    let helpMsg = 'Click to start drawing';
    if (this.sketch) {
      const geom = (this.sketch.getGeometry());
      if (geom instanceof OlGeomPolygon) {
        helpMsg = continuePolygonMsg;
      } else if (geom instanceof OlGeomLineString) {
        helpMsg = continueLineMsg;
      }
    }

    this.helpTooltipElement.innerHTML = helpMsg;
    this.helpTooltip.setPosition(evt.coordinate);
    this.helpTooltipElement.classList.remove('hidden');
  };

  createDrawInteraction(type: String): void {
    this.draw = new OlInteractionDraw({
      source: this.source,
      type: type,
      style: new OlStyleStyle({
        fill: new OlStyleFill({
          color: 'rgba(255, 255, 255, 0.2)'
        }),
        stroke: new OlStyleStroke({
          color: 'rgba(0, 0, 0, 0.5)',
          lineDash: [10, 10],
          width: 2
        }),
        image: new OlStyleCircle({
          radius: 5,
          stroke: new OlStyleStroke({
            color: 'rgba(0, 0, 0, 0.7)'
          }),
          fill: new OlStyleFill({
            color: 'rgba(255, 255, 255, 0.2)'
          })
        })
      })
    });
  }

  createHelpTooltip() {
    const { olMap }: MeasurePopupProps = this.props;
    if (this.helpTooltipElement) {
      this.helpTooltipElement.parentNode.removeChild(this.helpTooltipElement);
    }
    this.helpTooltipElement = document.createElement('div');
    this.helpTooltipElement.className = 'tooltip hidden';
    this.helpTooltip = new OlOverlay({
      element: this.helpTooltipElement,
      offset: [15, 0],
      positioning: 'center-left'
    });
    this.helpTooltip.typeId = "measure-tooltip";
    olMap.addOverlay(this.helpTooltip);
  }

  createMeasureTooltip() {
    const { olMap }: MeasurePopupProps = this.props;
    if (this.measureTooltipElement) {
      this.measureTooltipElement.parentNode.removeChild(this.measureTooltipElement);
    }

    this.measureTooltipElement = document.createElement('div');
    this.measureTooltipElement.className = 'tooltip tooltip-measure';
    this.measureTooltip = new OlOverlay({
      element: this.measureTooltipElement,
      offset: [0, -15],
      positioning: 'bottom-center'
    });
    this.measureTooltip.typeId = "measure-tooltip";
    olMap.addOverlay(this.measureTooltip);
  }

  formatLength(line: OlGeomLineString): String {
    const length = OlSphere.getLength(line);
    let output;
    if (length > 100) {
      output = (Math.round(length / 1000 * 100) / 100) + ' km';
    } else {
      output = (Math.round(length * 100) / 100) + ' m';
    }
    return output;
  };

  formatArea(polygon: OlGeomPolygon): String {
    const area = OlSphere.getArea(polygon);
    let output;
    if (area > 10000) {
      output = (Math.round(area / 1000000 * 100) / 100) + ' km\u00B2';
    } else {
      output = (Math.round(area * 100) / 100) + ' m\u00B2';
    }
    return output;
  };

  formatCoordinates(point: OlGeomPoint): String {
    const { coordinateSystem } = this.state;
    const coordinate = point.getLastCoordinate();
    const transformedCoordinates = OlProj.transform([coordinate[0], coordinate[1]], "EPSG:3857", coordinateSystem.value);

    let output;
    if (coordinateSystem.value === "EPSG:4326") {
      let northing = (Math.round(transformedCoordinates[1] * 1000000) / 1000000);
      let easting = (Math.round(transformedCoordinates[0] * 1000000) / 1000000);
      const northingDirection = northing >= 0 ? 'N' : 'S';
      const eastingDirection = easting >= 0 ? 'E' : 'W';
      output = Math.abs(northing) + northingDirection + ' ' + Math.abs(easting) + eastingDirection;
    }     
    else {
      output = (Math.round(transformedCoordinates[1] * 100) / 100) + ' ' + (Math.round(transformedCoordinates[0] * 100) / 100);
    }
    return output;
  };

  componentDidUpdate(): void {
    const { t } = this.props;
    this.measureControl.ref.title = t('Measure tools');
  }

  render(): React.Node {
    const { t } = this.props;
    const { visible, lastMeasurement, coordinateSystem, allowedCoordinateSystems } = this.state;
    if (visible) {
      return (
        <Draggable
          bounds="parent"
          handle=".measurementHandle"
          defaultPosition={{ x: 40, y: 40 }}
          position={null}
          grid={[1, 1]}>
          <PopupWindow>
            <PopupHeader
              className='measurementHandle'
            >
              {t('Measurements')}
              <CloseButton onClick={() => this.close()}>
                <img src={IconClose} alt={t('Close')} />
              </CloseButton>
            </PopupHeader>
            <PopupContent>

              <MeasurementValue
                visible={lastMeasurement !== ''}>
                <p>{t('Last measurement')}:</p>
                <b>{lastMeasurement}</b>
              </MeasurementValue>

              <SelectInput
                defaultValue={coordinateSystem.value}
                onChange={(e) => {
                  const selectedSystem = allowedCoordinateSystems.find(system => system.value === e.target.value)
                  this.setState({ coordinateSystem: selectedSystem })
                }}
              >
                {allowedCoordinateSystems.map(system => {
                  return (
                    <option
                      key={`coordinateSystem_${system.value}`}
                      value={system.value}
                    >
                      {t(system.name)}
                    </option>
                  )
                })}
              </SelectInput>

              <MeasureButton
                onClick={() => this.measurePoint()}>
                <StyledIcon src={IconMeasurePoint} />
                {t('Coordinates')}
              </MeasureButton>
              <MeasureButton
                onClick={() => this.measureDistance()}>
                <StyledIcon src={IconMeasureDistance} />
                {t('Distance')}
              </MeasureButton>
              <MeasureButton
                onClick={() => this.measureArea()}>
                <StyledIcon src={IconMeasureArea} />
                {t('Area')}
              </MeasureButton>
              <MeasureButton
                onClick={() => this.clear()}>
                <StyledIcon src={IconClear} />
                {t('Clear')}
              </MeasureButton>
            </PopupContent>
          </PopupWindow>
        </Draggable>
      );
    } else {
      return null;
    }
  }
};

export default translate("translations")(MeasurePopup);


// WEBPACK FOOTER //
// ./src/containers/content/map/popups/MeasurePopup.jsx